export const environment = {
    production: false,
    apiUrl: 'https://api.cohabapp.qual.cawita.com',
    assetUrl: 'https://assets.cohabapp.qual.cawita.com',
    customerSpaceUrl: 'https://share.cohabapp.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};